export default __webpack_public_path__ + "static/media/truck_2_3.1e0b629e.svg";